import Material from './Material';

interface ReductionAction {
    id: number;
    priority: number;
    name: string;
    materials: Material[];
    enabled: boolean;
}

const EmptyReductionAction: ReductionAction = {
    id: 0,
    priority: 0,
    name: '',
    materials: [],
    enabled: true
};

export { EmptyReductionAction };

export default ReductionAction;
